import useDialog from "../contexts/DialogProvider";
import { useSnackbar } from "../contexts/SnackbarProvider";
import { useApi } from "../contexts/ApiProvider";
import { useTranslation } from "react-i18next";

const useDeleteData = (itemTitle: string, deleteUrl: string) => {
  const showDialog = useDialog();
  const showMessage = useSnackbar();
  const api = useApi();
  const { t } = useTranslation();

  const deleteHandler = () => {
    showDialog({
      title: t("Delete WHAT", { what: itemTitle }),
      text: t("Do you really want to delete WHAT", {
        what: itemTitle,
      }),
      buttons: [
        { label: t("No") },
        {
          label: t("Yes"),
          clickCallback: async () => {
            const response = await api.delete(deleteUrl);
            if (response.ok) {
              showMessage({
                text: t("Deleted WHAT successfully", {
                  what: itemTitle,
                }),
                severity: "success",
              });
            } else {
              showDialog({
                title: t("Deleting WHAT failed", { what: itemTitle }),
                text: t("Please, try again."),
              });
            }
          },
        },
      ],
    });
  };

  return deleteHandler;
};

export default useDeleteData;
